<template>
  <!-- 提现管理 -->
  <div class="home-page-container">
    <!-- notice 公告-->
    <el-card shadow="never">
      <div class="notice-wrapper">
        <i class="el-icon-message-solid"></i>
        <div class="info">
          <el-carousel height="112px" direction="vertical" :autoplay="true" :interval="6000" indicator-position="none" arrow="never">
            <el-carousel-item v-for="(item,index) in notice" :key="index" class="info-item">
              <!-- 兼容宙斯html标签的返回 -->
              <p v-html="getXssIntro(item)"></p>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </el-card>
    <!-- 禁止提现提示 -->
    <div class="no-withdraw g-flex-c" v-if="noWithdrawStr">
      <i class="el-icon-warning"></i>
      <p class="content">{{noWithdrawStr}}</p>
    </div>
    <!-- 主体选择 -->
    <div v-show="signBodyList.length > 1" style="margin-top: 20px;">
      <el-select v-model="currentBody" @change="changeCurrentBody" placeholder="请选择" size="mini">
        <el-option v-for="item in signBodyList" :key="item.code" :label="item.desc" :value="item.code"></el-option>
      </el-select>
    </div>
    <div class="g-flex-sb" style="margin-top: 20px;">
      <!-- 账户概览 -->
      <!-- <div class="account_overview">
        <h4>账户总览（单位/元）</h4>
        
        <div>
          总资金
          <el-popover width="230" trigger="hover" content="当前商户的各账户余额之和">
            <i slot="reference" class="el-icon-question" style="color: #aaa"></i>
          </el-popover>
        </div>
        <div class="count">{{ overviewInfo.totalAmount || '0.00' }}</div>

        <div class="basic_account">
          <div class="title">基本账户</div>
          <div>
            可提现资金
            <el-popover width="300" trigger="hover" content="订单到了结算周期后,应结金额会进入到可提现账户内,只有该账户的资金支持提现">
              <i slot="reference" class="el-icon-question" style="color: #aaa"></i>
            </el-popover>
          </div>
          <div class="count">{{ overviewInfo.withdrawableBalance || '0.00' }}</div>
        </div>
      </div> -->
      <!-- 可提现资金管理 -->
      <div class="withdraw_funds">
        <h4>可提现资金提现</h4>

        <div class="item">
          <span class="label">当前账户</span>
          <!-- <el-radio-group v-model="validAccount" @change="changeAccount">
            <el-radio v-for="item in allAccounts" :key="item.accountCode" :label="item.accountCode">{{ `${item.accountName}(¥${item.balance || '0.00'})` }}</el-radio>
          </el-radio-group> -->
          <div>
            <div>
              <el-radio v-model="accountType" :label="10" @input="changeAccountType">资金账户</el-radio>
              <span>
                提现中资金¥{{ pendingAmount || '0.00' }}
                <el-popover width="300" trigger="hover" content="可提现资金发起提现后,金额会进入到提现中资金,当提现成功后资金将到对应的提现账户">
                  <i slot="reference" class="el-icon-question" style="color: #aaa"></i>
                </el-popover>
              </span>
              <span class="checkRecord" @click="onRecord">查看记录&gt;</span>
            </div>
            <div style="margin-top: 20px;">
              <el-radio v-model="accountType" :label="0" @input="changeAccountType">清分账户</el-radio>
              <el-select v-model="validAccount" placeholder="请选择" size="mini" @change="changeAccount" :disabled="accountType === 10">
                <el-option
                  v-for="item in accountOptions"
                  :key="item.accountCode"
                  :label="item.accountName"
                  :value="item.accountCode">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>

        <div class="item">
          <span class="label">
            提现账户
            <el-popover width="300" trigger="hover" content="如需变更提现账户，请联系能链城市经理">
              <i slot="reference" class="el-icon-question" style="color: #aaa"></i>
            </el-popover>
          </span>
          <span>{{accountInfo.companyName || ''}}</span>
        </div>
        
        <div class="item">
          <span class="label">
            提现方式
            <!-- <el-popover width="300" trigger="hover" content="设置成功后，对所有账户生效">
              <i slot="reference" class="el-icon-question" style="color: #aaa"></i>
            </el-popover> -->
          </span>
          <el-radio-group v-model="autoWithdraw.flag" v-if="allAccounts.length >= 1">
            <el-radio :label="0">手动提现</el-radio>
            <el-radio :label="1">自动提现</el-radio>
          </el-radio-group>
          <span class="tips" v-show="validAccount === 3">
            操作自动提现或手动提现视为您已同意<span @click="handleProtocol">《中信银行e管家业务平台子商户服务协议 》</span>
          </span>
        </div>

        <div v-show="autoWithdraw.flag === 1">
          <!-- 若需显示具体时间，下述可改 -->
          <el-link icon="el-icon-edit" @click="autoConfig" class="auto-edit" :disabled="!!noWithdrawStr">{{autoTimeInfo}}</el-link>

          <div class="item">
            <span class="label">附言</span>
            <div class="remark" @click="onSetRemark">
              <i class="el-icon-edit"></i>
              <span>{{ `${remarkPrefix}-${remark}` }}</span>
            </div>
          </div>
        </div>

        <template v-if="autoWithdraw.flag === 0 && allAccounts.length >= 1">
          <div class="item g-flx" style="align-items: center;">
            <span class="label required">提现金额</span>

            <!-- 选择资金账户展示 -->
            <div v-if="accountType === 10">
              <el-radio :label="0" v-model="amountRadio" @change="changeAmountRadio">按订单结算时间汇总金额</el-radio>
              <span v-show="amountRadio === 0">{{ `（¥${amountOfTime}）` }}</span>
              <span>{{ ` ${accountInfo.startTime || ''} 至 ` }}</span>
              <el-date-picker v-model="withdrawForm.endTime" @change="changeEndTime" type="datetime" size="mini" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59" placeholder="选择日期时间" :disabled="amountRadio !== 0" :picker-options="pickerOptions"></el-date-picker>
              <el-popover width="330" trigger="hover" content="开始时间默认为上次自动或手动提现最晚一笔订单结算时间">
                <i slot="reference" class="el-icon-question" style="color: #aaa"></i>
              </el-popover>
              <el-radio :label="1" v-model="amountRadio" @change="changeAmountRadio" style="margin-left: 20px;">
                全部金额
                <span v-show="amountRadio === 1">(¥{{ accountInfo.balance.toFixed(2) }})</span>
              </el-radio>
            </div>

            <!-- 选择清分账户展示 -->
            <div v-else>
              <el-radio :label="2" v-model="amountRadio" @change="changeAmountRadio">按自定义金额</el-radio>
              <span v-show="amountRadio === 2">{{ `(账户金额：¥${accountInfo.balance.toFixed(2) || ''}) ` }}</span>
              <el-input placeholder="请输入金额,保留两位小数" v-model="withdrawForm.amount" maxlength="15" clearable style="width: 300px;" size="mini" :disabled="amountRadio !== 2"></el-input>
              <el-radio :label="3" v-model="amountRadio" @change="changeAmountRadio" style="margin-left: 20px;">
                全部金额
                <span v-show="amountRadio === 3">(¥{{ accountInfo.balance.toFixed(2) }})</span>
              </el-radio>
            </div>
          </div>

          <div class="item">
            <span class="label">附言</span>
            <div class="remark" @click="onSetRemark">
              <i class="el-icon-edit"></i>
              <span>{{ `${remarkPrefix}${remark ? '-' + remark : remark}` }}</span>
            </div>
            <!-- <el-input type="textarea" placeholder="请输入30字以内附言" v-model="withdrawForm.remark" maxlength="30" show-word-limit clearable style="width: 300px;vertical-align: middle;"></el-input> -->
          </div>

          <!-- 提交按钮 -->
          <div class="submit-wrapper">
            <el-button type="primary" class="submit-btn" :loading="submitLoading" @click="checkSubmit" :disabled="!!noWithdrawStr">点击提现</el-button>
          </div>
        </template>
      </div>
    </div>
    <!-- 自动提现配置 -->
    <withdraw-config v-if="dialogFlag==='config'" :info="withdrawInfo" :signBody="validAccount || accountType" :supportsAutoWithdraw="supportsAutoWithdraw" @close="closeWithdraw"></withdraw-config>
    <!-- 中顺易统一协议 -->
    <withdraw-agreement v-if="dialogFlag==='zsy'" @close="dialogFlag='';useGetAccountDetail();" @exit="gotoHome()"></withdraw-agreement>
    <!-- 平安鉴权 -->
    <withdraw-auth v-if="dialogFlag==='auth'" :bankForm="authInfo" @close="dialogFlag='';useGetAccountDetail();" @exit="gotoHome()"></withdraw-auth>
    <el-dialog :visible.sync="withdrawAuthVisible" :title="cmsContent.title" center>
      <div v-html="cmsContent.content"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="withdrawAuthVisible = false">我已阅读</el-button>
      </span>
    </el-dialog>
    <!-- 查看记录弹窗 -->
    <el-dialog :visible.sync="recordVisible" title="提现中资金记录" width="80%" center>
      <div class="record_tips">提示：提现成功后，可在资金流水查看提现记录</div>
      <el-table
        :data="recordData"
      >
        <el-table-column prop="requestTime" label="提现请求时间" align="center"></el-table-column>
        <el-table-column prop="businessCode" label="业务订单" align="center"></el-table-column>
        <el-table-column prop="tradeAmount" label="交易金额（元）" align="center"></el-table-column>
        <el-table-column prop="companyName" label="商户名称" align="center"></el-table-column>
        <el-table-column prop="companyId" label="商户编码" align="center"></el-table-column>
        <el-table-column prop="signBody" label="签约主体" align="center"></el-table-column>
        <el-table-column prop="cleanBank" label="清分银行" align="center"></el-table-column>
        <el-table-column label="提现时间范围" align="center" width="150">
          <template slot-scope="scope">
            {{ scope.row.withdrawalStartTime }}至{{ scope.row.withdrawalEndTime }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="付款附言" align="center"></el-table-column>
        <el-table-column prop="withdrawalStatus" label="提现状态" align="center"></el-table-column>
      </el-table>
      <div class="button_group">
        <el-button size="mini" @click="recordVisible = false">返回</el-button>
      </div>
    </el-dialog>
    <!-- 设置附言 -->
    <el-dialog :visible.sync="remarkVisible" title="附言设置" width="800px" center :show-close="false">
      <div style="padding: 0 30px;color: #000;">
        <p>1. 附言默认格式为：结算款-{商户ID}-{自定义附言}，其中结算款、{商户ID}为固定内容</p>
        <p>2. 附言设置成功后，对商户下的所有账户生效，含自动提现、手动提现</p>
        <div class="custom_remark">
          <span>自定义附言：</span>
          <el-input v-model="remark" placeholder="请输入20字以内附言" :maxlength="20" clearable></el-input>
        </div>
        <div class="button_group">
          <el-button size="mini" @click="closeRemark">取消</el-button>
          <el-button size="mini" type="primary" @click="saveRemark">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { withdrawSubmitApi, isAllowWithdrawApi, getRuleDetail, getSignBodyList, getAccountDetail, getWithdrawAmount, pendingAmount, customRemark, bankTips } from '@/api/finance'
import WithdrawAgreement from './components/withdraw/agreement'
import WithdrawConfig from './components/withdraw/config'
import WithdrawAuth from './components/withdraw/authentication'
import accountMix from '@/views/finance/mixins/account'
import { getXssIntro } from '@/utils/xss'

export default {
  // name: 'finance_withdraw',
  mixins:[ accountMix ],
  components:{
    WithdrawAgreement,
    WithdrawConfig,
    WithdrawAuth
  },
  data(){
    const _this = this
    return {
      noWithdrawStr: '',     //不能提现原因
      notice: [],
      allAccounts: [],
      validAccount:'',
      autoWithdraw: {      
        flag: 0,
        time: [],
      },
      withdrawInfo: {},
      withdrawForm:{
        amount:'',
        endTime: ''
      },
      accountInfo:{
        balance: 0,
        autoWithdraw: false, //是否自动提现
        autoWithdrawInfo:'', //自动提现信息
        bankCardInfo:{},  //银行卡信息
        announcement:''  //公告信息
      },
      // zsy (中顺易) ｜ config （自动提现配置） ｜ auth (平安鉴权)
      dialogFlag:'',
      authInfo:'',   //平安鉴权
      submitLoading: false,
      withdrawAuthVisible: false,
      recordVisible: false,
      pendingAmount: '',
      recordData: [],
      cmsContent: {}, // 协议内容
      signBodyList: [],
      overviewInfo: {},
      currentBody: '',
      amountRadio: '',
      amountOfTime: '', // 按订单结算时间汇总金额
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(_this.accountInfo.startTime).getTime() - 24 * 3600 * 1000
        }
      },
      accountType: 10, //账户类型
      accountOptions: [], // 清分账户枚举
      remarkPrefix: '', // 附言前缀
      remark: '', // 自定义附言
      customRemark: '', // 保存的自定义附言
      remarkVisible: false,
      supportsAutoWithdraw: false // 是否支持自动提现
    }
  },
  computed: {
    autoTimeInfo (){
      return this.autoWithdraw.time ?  `每天 ${this.autoWithdraw.time} 自动提现` : '自动提现配置'
    }
  },
  created(){
    this.isAllowWithdraw()
    this.$track.pageViewEvent('页面：提现资金管理', '1634182515')

    this.useGetSignBodyList()
    
    this.searchWithdrawAmount()

    this.getBackTips()
  },  
  methods:{
    getXssIntro,
    /**
     * @description 代码乱的一批，但不怪我，怪原来写的就有问题，最后越改越乱
     */
    // 获取签约主体
    async useGetSignBodyList() {
      const { code, result } = await getSignBodyList()
      if (code !== 200) return
      const { accountStatus, clues, signBodyResponseInfoList } = result
      this.freezeAccount({ accountStatus, clues })
      this.signBodyList = signBodyResponseInfoList || []
      const defaultItem = signBodyResponseInfoList.find(item => item.use) || signBodyResponseInfoList[0]
      if (!defaultItem) return
      this.currentBody = defaultItem.code
      this.useGetAccountDetail(defaultItem.code)
    },
    changeCurrentBody() {
      this.accountType = 10
      this.useGetAccountDetail()
      this.searchWithdrawAmount()
    },
    // 获取账户详情
    async useGetAccountDetail(signBody, useOldAccount) {
      const { code, result } = await getAccountDetail({ signBody: signBody || this.currentBody })
      if (code !== 200) return
      const { totalAmount, withdrawableBalance, accountFinanceInfoList, remarkPrefix, customRemark, supportsAutoWithdraw } = result
      this.overviewInfo = {
        totalAmount,
        withdrawableBalance
      }
      this.remarkPrefix = remarkPrefix
      this.remark = customRemark || ''
      this.customRemark = customRemark
      this.supportsAutoWithdraw = supportsAutoWithdraw
      this.allAccounts = accountFinanceInfoList || []
      if (this.accountType === 10) {
        this.validAccount = ''
        this.changeAccount(10)
      } else {
        if (!useOldAccount) {
            this.validAccount = accountFinanceInfoList.find(item => item.currentAccount)?.accountCode
        }
        this.accountOptions = accountFinanceInfoList.filter(item => item.accountCode !== 10)
        this.changeAccount(this.validAccount)
      }
    },
    async changeEndTime(val) {
      const param = {
        accountCode: this.accountInfo.accountCode,
        signBody: this.currentBody,
        startTime: this.accountInfo.startTime,
        endTime: val
      }
      const { code, result } = await getWithdrawAmount(param)
      if (code !== 200) return
      this.amountOfTime = result.toFixed(2)
    },
    // 判断当前账户是否可提现
    async isAllowWithdraw () {
      try {
        const { code, result } = await isAllowWithdrawApi()
        if (code !== 200) return
        this.noWithdrawStr = result
      } catch (error) {
        console.log(error.message)
      }
    },
    //判断当前商户或油站该如何显示 开通协议，未开通协议
    // 2 中顺易 ｜ 1 平安 ｜ 0 华夏(会后端报错处理，没有账户信息)
    trafficPage(accountCode){
      let authInfnData = {}
      switch(accountCode){
        case 2: this.dialogFlag = 'zsy'; break
        case 1: 
          authInfnData = {
            ...this.accountInfo.bankCardInfo,
            peaceAuthPage: this.accountInfo.peaceAuthPage,  //需要显示对状态
            verifyNum: this.accountInfo.verifyNum,      //剩余鉴权次数
            waitSeconds: this.accountInfo.waitSeconds    //需要等待的秒数
          }
          this.dialogFlag = 'auth'
          this.authInfo = authInfnData
          break
        default: 
          this.dialogFlag = ''
      }  
    },
    //初始化提现方式
    initWithdraw(accountInfo){
      // 获取公告 ['公告中']
      // this.notice = (accountInfo.announcement && accountInfo.announcement.length) ? accountInfo.announcement : []
      this.autoWithdraw.flag = accountInfo.autoWithdraw ? 1 : 0 
      this.autoWithdraw.time = accountInfo.withdrawTimeList ? accountInfo.withdrawTimeList.join('、') : ''
    },
    //切换当前账户
    changeAccount(accountCode){
      this.accountInfo = this.allAccounts.find(item => item.accountCode === accountCode ) || {}
      this.accountInfo.withdrawTimeList = this.accountInfo.withdrawTimeList.map(item => {
        const val = item.split(':').join('')
        return val.slice(0,2)+':'+val.slice(2,4)
      })
      this.amountRadio = null
      this.initWithdraw(this.accountInfo)
      if (accountCode === 10) {
        this.withdrawForm.endTime = ''
      } else {
        this.withdrawForm.amount = ''
      }
    },
    changeAccountType(val) {
      if (val === 0) {
        this.useGetAccountDetail()
        return
      }
      this.validAccount = ''
      this.changeAccount(val)
    },
    changeAmountRadio(val) {
      if (val !== 0) {
        this.withdrawForm.endTime = ''
      }
      if (val === 3) {
        this.withdrawForm.amount = this.accountInfo.balance
      }
    },
    //check 提交之前的一些校验
    checkSubmit(){
      if (this.accountType !== 10 && this.autoWithdraw.flag === 0) {
        if (this.withdrawForm.amount > this.accountInfo.balance) {
          this.$message.error('提现金额不可大于账户余额')
          return
        } else if (this.amountRadio === 2 &&!/^\d+(\.\d{0,2})?$/.test(this.withdrawForm.amount)) {
          this.$message.error('请输入正确金额,且最多保留两位小数')
          return
        }
      }
      this.$track.clickEvent('提现资金管理-手动提现', '1621476238')
      const data = { 
        ...this.withdrawForm, 
        accountCode: this.accountInfo.accountCode,
        signBody: this.currentBody,
        startTime: this.accountInfo.startTime,
        remark: this.remarkPrefix + this.remark
      }
      this.withdrawSubmit(data)
    },
    async withdrawSubmit(data){
      try{
        this.submitLoading = true
        const { code, result = {} } = await withdrawSubmitApi(data)
        console.log(result)
        if(code === 200){
          this.$message.success('提现申请成功, 100万以下一般实时到账，最晚2小时内到账，请注意查看您银行卡账户余额');
          this.withdrawForm.amount = ''
          this.amountOfTime = ''
          this.useGetAccountDetail(this.currentBody, true)
          this.searchWithdrawAmount()
        } 
      }catch(err){
        console.log(err)
      }finally{
        this.submitLoading = false
      }
    },
    autoConfig(){
      this.dialogFlag = 'config'
      const { withdrawTimeList, autoWithdraw } = this.accountInfo
      this.withdrawInfo = {
        // 本期禁止自动提现，autoWithdraw固定传false
        autoWithdraw,
        withdrawTimeList,
        accountCode: this.accountInfo.accountCode
      }
    },
    gotoHome(){
      // 修改,肯定有订单列表页
      this.$router.push({path:'/order/orderList'})
    },
    //处理需要冻结的账户,不允许提现，并展示错误原因
    /**
     * accountStatus:  账户状态，0 冻结，1 正常
     * clues: 冻结原因
     */
    freezeAccount({accountStatus,clues}){
      if(accountStatus === 1) return
      //展示提现原因，禁止提现，兼容无返回原因
      this.noWithdrawStr = clues || '商户账户冻结，请联系能链财务人员'    
    },
    async handleProtocol() {
      this.withdrawAuthVisible = true
      const { code, result } = await getRuleDetail({ protocolCode: 31934 })
      if (code !== 200) return
      this.cmsContent = result || {}
    },
    // 查询提现中资金
    async searchWithdrawAmount() {
      const { code, result } = await pendingAmount({ signBody: this.currentBody })
      if (code !== 200) return
      this.pendingAmount = result.pendingAmount.toFixed(2)
      this.recordData = result.pendingTransactions
    },
    // 查询银行通知
    async getBackTips() {
      const { code, result } = await bankTips()
      if (code !== 200) return
      this.notice = [result]
    },
    onRecord() {
      this.searchWithdrawAmount()
      this.recordVisible = true
    },
    onSetRemark() {
      this.remarkVisible = true
    },
    // 保存自定义附言
    async saveRemark() {
      const reg = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/
      if (this.remark && !reg.test(this.remark)) {
        this.$message.error('输入内容不正确，只能包含中文、英文、数字')
        return
      }
      const { code, message } = await customRemark({ customRemark: this.remark })
      if (code !== 200) return this.$message.error(message)
      this.$message.success('保存成功')
      this.customRemark = this.remark
      this.remarkVisible = false
    },
    closeRemark() {
        this.remark = this.customRemark
        this.remarkVisible = false
    },
    closeWithdraw({ autoWithdraw, withdrawTimeList }) {
      this.dialogFlag = ''
      if (withdrawTimeList) this.accountInfo.withdrawTimeList = withdrawTimeList
      if (autoWithdraw) this.accountInfo.autoWithdraw = autoWithdraw
      this.initWithdraw(this.accountInfo)
    }
  }
}
</script>
<style lang="less" scoped>
.home-page-container{
  margin-top: 20px;
}
.notice-wrapper{
  display: flex;
  align-items: center;
  .info{
    margin-left: 10px;
    color: #222;
    font-size: 14px;
    line-height: 1.25;
    width: 100%;
    .info-item{
      display: flex;
      align-items: center;
      span{
        word-break: break-all;
      }
    }
  }
}
.submit-wrapper{
  width: 100%;
  .submit-btn{
    display: block;
    margin: 20px auto;
    width: 184px;
    height: 40px;
  }
}
.auto-edit{
  font-size: 12px;
  margin-left: 100px;
  margin-top: 20px;
}
.tips {
  font-size: 14px;
  margin-left: 20px;
  span {
    color: #409EFF;
    cursor: pointer;
  }
}
.no-withdraw{
  width: 100%;
  margin-top: 10px;
  padding: 5px 15px;
  background: #FFEDED;
  border-radius: 2px;
  font-size: 14px;
  color: #FF2929;
  word-break: break-all;
  .content{
    margin-left: 15px;
  }
}
.account_overview {
  width: 400px;
  height: 450px;
  background-color: #fff;
  padding: 5px 15px;
  .count {
    font-weight: 600;
    margin-top: 15px;
  }
  .basic_account {
    border: 1px solid #eee;
    margin-top: 15px;
    padding: 10px;
    .title {
      font-weight: 600;
      margin-bottom: 20px;
    }
  }
}
.withdraw_funds {
  height: 450px;
  padding: 5px 15px;
  flex: 1;
  background-color: #fff;
  .item {
    display: flex;
    margin-top: 30px;
    font-size: 14px;
    .checkRecord {
      margin-left: 20px;
      font-size: 12px;
      cursor: pointer;
    }
    .remark {
      color: #9FA09F;
      cursor: pointer;
      span {
        margin-left: 10px;
      }
    }
  }
  .label {
    font-weight: 600;
    width: 100px;
    display: inline-block;
  }
  .item:last-child {
    margin-bottom: 20px;
  }
}
.required::before {
  content: '*';
  color: red;
  margin-right: 2px;
}
.record_tips {
  margin-bottom: 5px;
  color: #909399;
}
.button_group {
  margin-top: 30px;
  text-align: center;
}
.custom_remark {
  display: flex;
  align-items: center;
  margin-top: 40px;
  span {
    width: 100px;
    margin-right: 20px;
  }
}
</style>